import React, { Suspense } from "react";
import { Redirect, Switch } from "react-router-dom";
import { LayoutSplashScreen, ContentRoute } from "../_metronic/layout";
import { BuilderPage } from "./pages/BuilderPage";
import { DashboardPage } from "./pages/DashboardPage";
import RoomTypes from "./pages/RoomTypes";
import MasterUserPage from "./pages/master-user/MasterUserPage"
import DevicesPage from "./pages/devices/DevicesPage";
import Icons from "./pages/Icons";
import Faq from "./pages/Faq";
import DefaultSettingPage from "./pages/default-settings/DefaultSettingPage";
import FirmwareFilePage from "./pages/firmware-files/FirmwareFilePage";
import SubOrdinateUser from "./pages/SubUser";
import DeviceAppliances from "./pages/DeviceAppliances";


// const MasterUserPage = lazy(() =>
// 	import("./pages/master-user/MasterUserPage")
// );

export default function BasePage() {

	return (
		<Suspense fallback={<LayoutSplashScreen />}>
			<Switch>
				{
					<Redirect exact from={"/"} to={"/dashboard"} />
				}
				<ContentRoute path={"/dashboard"} component={DashboardPage} />
				<ContentRoute path={"/builder"} component={BuilderPage} />
				<ContentRoute exact path={"/subordinate-user"} component={SubOrdinateUser} />
				<ContentRoute exact path={"/subordinate-user/:id"} component={SubOrdinateUser} />
				<ContentRoute path={"/room-types"} component={RoomTypes} />
				<ContentRoute path={"/master-user"} component={MasterUserPage} />
				<ContentRoute path={"/devices"} component={DevicesPage} />
				<ContentRoute path={"/icons"} component={Icons} />
				<ContentRoute path={"/faq"} component={Faq} />
				<ContentRoute path={"/default-settings"} component={DefaultSettingPage} />
				<ContentRoute path={"/firmware-file"} component={FirmwareFilePage} />
				<ContentRoute path={"/device-appliances"} component={DeviceAppliances} />

				<Redirect to={"/error/error-v1"} />
			</Switch>
		</Suspense>
	);
}
